import { makeAutoObservable } from 'mobx';
import { toast } from 'react-toastify';
import { ISession } from '../types/Session';
import { SessionService } from '../services';

export default class SessionStore {
    activeSession: ISession | null = null;

    sessionList: ISession[] = [];

    validSessionList: ISession[] = [];

    sessionsLoading: boolean = false;

    validSessionsLoading: boolean = false;

    error: any;

    private sessionService: typeof SessionService;

    constructor() {
        this.sessionService = SessionService;
        makeAutoObservable(this);
    }

    setSession(session: ISession | null): void {
        this.activeSession = session;
    }

    private setSessionsLoading(value: boolean): void {
        this.sessionsLoading = value;
    }

    private setValidSessionsLoading(value: boolean): void {
        this.validSessionsLoading = value;
    }

    private setError(error: any): void {
        // eslint-disable-next-line no-console
        console.error(error);
        this.error = error;
        toast.error(error.message);
    }

    clearAllData(): void {
        this.sessionList = [];
        this.setSession(null);
    }

    private pushNewValidSessions(
        sessions: ISession[],
        userEmail: string,
    ): void {
        sessions.forEach((session) =>
            this.validSessionList.push({ ...session, user_id: userEmail }),
        );
    }

    private pushNewSessions(sessions: ISession[], userEmail: string): void {
        sessions.forEach((session) =>
            this.sessionList.push({ ...session, user_id: userEmail }),
        );
    }

    async fetchSessions(userEmail: string): Promise<void> {
        try {
            this.setSessionsLoading(true);
            const sessions: ISession[] =
                await this.sessionService.fetchSessions(userEmail);
            this.pushNewSessions(sessions, userEmail);
            this.setSessionsLoading(false);
        } catch (error) {
            this.setSessionsLoading(false);
            this.setError(error);
        }
    }

    async fetchValidSessions(userEmail: string): Promise<void> {
        try {
            this.setValidSessionsLoading(true);
            const sessions: ISession[] =
                await this.sessionService.fetchValidSessions(userEmail);
            this.pushNewValidSessions(sessions, userEmail);
            this.setValidSessionsLoading(false);
        } catch (error) {
            this.setValidSessionsLoading(false);
            this.setError(error);
        }
    }
}
